import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	CanActivateChild,
	Router,
	RouterStateSnapshot,
} from '@angular/router';
import { map, tap } from 'rxjs';

// --- Facades ---
import { AuthFacade } from '@facades/auth.facade';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
	private readonly isAuthenticated$ = this.authFacade.authState$.pipe(
		map(({ isAuthenticated }) => Boolean(isAuthenticated))
	);

	constructor(private _router: Router, private authFacade: AuthFacade) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		return this.isAuthenticated$.pipe(
			tap(isAuthenticated => {
				if (!isAuthenticated) this._router.navigate(['/auth']);
			})
		);
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		return this.canActivate(route, state);
	}
}
